import qs from 'qs';
import { IS_PRODUCTION } from '@/constants/config';

const API_BASE_PATH = '/wuji';

const SCHEMA_KEY = {
  notice: 'b50c73a1d84141fcbbd388c504f148e0',
  common_config: '4f40ea3c5da648d09a07d54337a6056f',
  table_column_config: '7f5e5c1f5582493db2fd5c149f86f5cf',
  micro_app_config: '8d139f292cd54c01ad5cf7e0cd5748b9',
  form_render_config: 'f7f04b4262f64b6f82d1e3dd738667d0', // 任务系统 form_render
  feature_field_config: 'b3f0fd5fd9674a83af1bb85385a04de7',
};

const SCHEMA_KEY_TEST = {
  notice: '5c25a32644624837868a1ff6e4d2b7d5',
  common_config: 'e3b4093fbae34d42bcdeeb44040b9924',
  table_column_config: '8c9ae88bc9e5493797214d07d7b5064a',
  micro_app_config: 'ee6cdfd771e14f3c8a123f942076cc25',
  form_render_config: 'f7f04b4262f64b6f82d1e3dd738667d0', // 任务系统 form_render
  feature_field_config: '819c0d8dc2174f3ab4bdd37ad6d9bef4',
};

const getParams = (key: string) => {
  return qs.stringify({
    appid: IS_PRODUCTION ? 'agency' : 'agency_test',
    schemakey: IS_PRODUCTION ? SCHEMA_KEY[key] : SCHEMA_KEY_TEST[key],
    schemaid: key,
    size: 'total',
  });
};

// 任务系统wuji配置
const getTaskParams = (key: string) => {
  return qs.stringify({
    appid: IS_PRODUCTION ? 'agency_task' : 'agency_task_test',
    schemakey: IS_PRODUCTION ? SCHEMA_KEY[key] : SCHEMA_KEY_TEST[key],
    schemaid: key,
    size: 'total',
  });
};

const getAdhomeParams = (key: string) => {
  return qs.stringify({
    appid: IS_PRODUCTION ? 'ADHome' : 'ADHome_test',
    schemakey: IS_PRODUCTION ? SCHEMA_KEY[key] : SCHEMA_KEY_TEST[key],
    schemaid: key,
    size: 'total',
  });
};

// 主键 ID
const ADHOMEKEYID = {
  indicator_blacklist: '61c069bddf925a012bade9e8',
  indicator_whitelist: '61c06a28df925a012bade9fc',
};

const ADHOMEKEYID_TEST = {
  indicator_blacklist: '61c03e2eb81bd9012f5fa381',
  indicator_whitelist: '61c03dc0990e9e016ecd10a8',
};

const getAdhomeKeyId = (key: string) => {
  const map = IS_PRODUCTION ? ADHOMEKEYID : ADHOMEKEYID_TEST;
  return map[key];
};

export default {
  // 公告
  notice: `${API_BASE_PATH}?${getParams('notice')}`,
  // 通用配置
  common_config: `${API_BASE_PATH}?${getParams('common_config')}`,
  // 表格列相关配置
  table_column_config: `${API_BASE_PATH}?${getParams('table_column_config')}&join=column`,
  // 微应用配置
  micro_app_config: `${API_BASE_PATH}?${getParams('micro_app_config')}`,
  // 表单form_render配置
  form_render: `${API_BASE_PATH}?${getParams('form_render_config')}`,
  // 任务系统 form_render
  task_form_render: `${API_BASE_PATH}?${getTaskParams('form_render_config')}`,
  // 获取 adhome 客户两率客户集团黑名单
  indicator_blacklist: `https://v.qq.com/cache/wuji_public/object/${getAdhomeKeyId('indicator_blacklist')}?${getAdhomeParams('feature_field_config')}`,
  // 获取 adhome 客户两率客户集团白名单
  indicator_whitelist: `https://v.qq.com/cache/wuji_public/object/${getAdhomeKeyId('indicator_whitelist')}?${getAdhomeParams('feature_field_config')}`,
};
